import { useTranslation } from "react-i18next";

interface NewFormsExperienceListHintProps {
  isExclusionList: boolean;
}

export const NewFormsExperienceListHint = ({ isExclusionList }: NewFormsExperienceListHintProps) => {
  const { t } = useTranslation("portal");

  return (
    <p className="text-xs text-muted-foreground">
      {isExclusionList
        ? t("The forms you choose here stay on the legacy version. Every other form uses the new experience.")
        : t("Only the forms you choose here use the new experience. Every other form stays on the legacy version.")}
    </p>
  );
};
